import PropTypes from 'prop-types';

export default PropTypes.shape({
    status: PropTypes.oneOf(['PENDING', 'COMPLETED', 'FAILED']),
    amount: PropTypes.number,
});



// WEBPACK FOOTER //
// ./safeTrade/withdrawalPropTypes.js